__turbopack_context__.v({
  "actions": "CookieChecker-module-scss-module__ZTqQeG__actions",
  "closeButton": "CookieChecker-module-scss-module__ZTqQeG__closeButton",
  "content": "CookieChecker-module-scss-module__ZTqQeG__content",
  "dialog": "CookieChecker-module-scss-module__ZTqQeG__dialog",
  "header": "CookieChecker-module-scss-module__ZTqQeG__header",
  "loginButton": "CookieChecker-module-scss-module__ZTqQeG__loginButton",
  "text": "CookieChecker-module-scss-module__ZTqQeG__text",
  "title": "CookieChecker-module-scss-module__ZTqQeG__title",
});
